import React, { useState } from "react";
import "./loginComponent.css";
import loginLogo from "../../assets/images/newLogo.png";
import LoginInputs from "../../commanComponents/inputs/LoginInputs";

import svgData from "../../constants/utilities/svgData";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import { useNavigate } from "react-router-dom";
import { communication } from "../../constants/apis/communication";
import { useMutation } from "react-query";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import Loader from "../../commanComponents/Loader";

const mineData = [
  { mineId: "BG01", name: "Balaghat" },
  { mineId: "DB01", name: "Dongri Buzurg" },
  { mineId: "TD01", name: "Tirodi" },
  { mineId: "CH01", name: "Chikla" },
  { mineId: "BL01", name: "Beldongri" },
  { mineId: "SP01", name: "Sitapatore" },
  { mineId: "GM01", name: "Gumgaon" },
  { mineId: "UK01", name: "Ukwa" },
  { mineId: "KD01", name: "Kandri" },
  { mineId: "MS01", name: "Munsar" },
];

export default function LoginComponent() {
  const [showPassword, setShowPassword] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState("");
  const [invalidCaptcha, setInvalidCaptcha] = useState(false);
  const [selectedMine, setSelectedMine] = useState("");
  const navigate = useNavigate();

  const mineIcon = (
    <svg width="40" height="40" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="27" fill="#2F3299" />
      <path d="M27 15c-5.5 0-10 4.5-10 10 0 7.5 10 17 10 17s10-9.5 10-17c0-5.5-4.5-10-10-10zm0 13.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z" fill="white" />
    </svg>
  );
  const tokenName = process.env.REACT_APP_PUBLIC_TOKENNAME;
  const userDetails = process.env.REACT_APP_PUBLIC_USERDETAILS;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isLoading } = useMutation((data) => communication?.login(data), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status === "SUCCESS") {
        toast.success(`Success : ${data?.data?.message}`);
        sessionStorage.setItem(tokenName, data?.data?.token);
        sessionStorage.setItem(userDetails, JSON.stringify(data?.data?.userDetails));
        navigate("/panel");
        return;
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to login: ${error?.message}`);
    },
  });

  function generateCaptcha() {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyz";
    let text = "";
    for (let i = 0; i < 6; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return text;
  }

  const handleLogin = (data) => {
    if (!captchaInput) {
      setInvalidCaptcha("Capcha is required");
      return;
    }
    if (captchaInput !== captcha) {
      toast.error("Invalid Capcha");
      return;
    }
    mutate(data);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="loginComponent">
        <div className="loginLeft">
          <div className="logoContainer">
            <img src={loginLogo} alt="MOIL Logo" />
            <h1>MOIL LIMITED</h1>
            <p>( A Government of India Enterprise )</p>
            <div className="store-buttons-container">
              <button type="button" className="store-btn badge-btn" onClick={() => window.open("/MOIL-LogBook-C-V3.apk", "_blank")}>
                <svg width="28" height="28" viewBox="0 0 24 24" style={{ marginRight: "10px" }}>
                  <path
                    fill="#00C0FF"
                    d="M2.753,23.111C2.551,22.923,2.44,22.646,2.44,22.282V1.718c0-0.364,0.111-0.641,0.313-0.829 c0.203-0.188,0.485-0.245,0.803-0.162l15.176,8.513c0.354,0.202,0.569,0.483,0.569,0.761c0,0.278-0.215,0.559-0.569,0.761 L3.556,23.274C3.238,23.356,2.956,23.299,2.753,23.111z"
                  />
                  <path fill="#FF3333" d="M18.733,9.239l-4.225-2.37L3.556,0.725L14.508,11.677L18.733,9.239z" />
                  <path fill="#FFD500" d="M20.242,10.086c0.669,0.382,1.066,0.912,1.066,1.439s-0.397,1.057-1.066,1.439l-3.41,1.913 l-4.225-4.225l4.225-4.225L20.242,10.086z" />
                  <path fill="#00E52C" d="M18.733,14.761l-4.225,2.37l-10.952,6.144l10.952-10.952L18.733,14.761z" />
                </svg>
                <div className="badge-text">
                  <span className="badge-small">GET IT ON</span>
                  <span className="badge-large">Google Play</span>
                </div>
              </button>
              <button type="button" className="store-btn badge-btn" onClick={() => window.open("https://www.apple.com/app-store/", "_blank")}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="#ffffff" style={{ marginRight: "10px" }}>
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.19 2.31-.88 3.5-.8 1.16.03 2.08.47 2.76 1.13-2.3 1.34-1.92 4.41.34 5.38-.45 1.34-1.12 2.74-2.04 3.93-1.09 1.44-2.04 2.87-3.08 2.87zm-1.78-15.65c.57-1.13.56-2.52-.3-3.63-1.09.28-2.43.98-3.14 2.05-.62.91-.71 2.28-.15 3.39 1.14-.14 2.38-.85 3.19-1.81z" />
                </svg>
                <div className="badge-text">
                  <span className="badge-small">Download on the</span>
                  <span className="badge-large">App Store</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div className="loginRight">
          <div className="loginFormContainer">
            <div className="formHeader">
              <h2>Login</h2>
              <p>
                <strong>Welcom Back !</strong> <span>Please login to your account</span>
              </p>
            </div>

            <form
              className="d-flex flex-column gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(handleLogin)();
              }}
            >
              <LoginInputs
                placeholder={"User ID"}
                icon={svgData?.profileLoginIcon}
                register={{ ...register("userId", { required: "User Id is Required" }) }}
                errorMessage={errors?.userId}
                style={{ backgroundColor: "transparent" }}
              />
              <LoginInputs
                placeholder={"Password"}
                register={{ ...register("password", { required: "Password is Required" }) }}
                errorMessage={errors?.password}
                type={showPassword ? "text" : "password"}
                icon={svgData?.lockIcon}
                eyeIcon={showPassword ? svgData?.showPassword : svgData?.hidePassword}
                setShowPassword={setShowPassword}
                showPassword={showPassword}
                style={{ backgroundColor: "transparent" }}
              />

              <div>
                <div className="loginInput">
                  {mineIcon}
                  <select
                    {...register("mineId", {
                      required: "Mine is Required",
                      onChange: (e) => setSelectedMine(e.target.value),
                    })}
                    defaultValue=""
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      width: "100%",
                      color: selectedMine ? "#333" : "#626262",
                      fontSize: "15px",
                      padding: "8px 0",
                      cursor: "pointer",
                    }}
                  >
                    <option value="" disabled style={{ color: "#888" }}>
                      Select Mine
                    </option>
                    {mineData.map((mine) => (
                      <option key={mine.mineId} value={mine.mineId} style={{ color: "#333" }}>
                        {mine.name}
                      </option>
                    ))}
                  </select>
                </div>
                {errors?.mineId && (
                  <p className="error-message text-danger text-start mb-0" style={{ marginTop: "4px" }}>
                    {errors.mineId.message}
                  </p>
                )}
              </div>

              <div className="formLinks">
                <p onClick={() => navigate("/login?page=reset")}>Reset password?</p>
                {/* <p onClick={() => navigate("/login?page=forgot")}>Forget password?</p> */}
              </div>
              <div className="captchaContainer">
                <div className="captchaWrapper">
                  <div className="captchaBox">{captcha}</div>
                  <div
                    className="captchaReload"
                    onClick={() => {
                      setCaptcha(generateCaptcha());
                    }}
                  >
                    {svgData?.reloadIcon}
                  </div>
                  <div className="captchaInputContainer">
                    <input
                      placeholder="Enter Captcha"
                      value={captchaInput}
                      onChange={(e) => {
                        setCaptchaInput(e.target.value);
                        setInvalidCaptcha(false);
                      }}
                    />
                  </div>
                </div>
                {invalidCaptcha && (
                  <div className="captchaErrorWrapper">
                    <div className="captchaError">
                      <span className="errorIcon">&times;</span>
                      <span>Invalid Captcha</span>
                    </div>
                  </div>
                )}
              </div>
              <ColorBtn
                text={"Login"}
                bgColor="#2F3299"
                color="#fff"
                style={{
                  boxShadow: "0px 4px 4px 0px #00000040",
                  border: "none",
                  width: "100%",
                  padding: "12px",
                  borderRadius: "6px",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
